export default __webpack_public_path__ + "static/media/sub-category-wellness-OutdoorSite.3cfb50a1.jpg";